<template>
    <router-view :key="$route.fullPath" @bgColor="bgColor"/>
</template>
<script>
export default {
    name: "index",
    methods:{
        bgColor(event){
            document.querySelector('body').style.backgroundColor = event;
        }
    }
}
</script>
